export default {
  postLogin(email, pass) {
    const obj = {
      actionType: appConstants.ActionTypes.POST_LOGIN,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('EMAIL_PARAM')] = email;
    obj.postData[Utils.getEndpointParam('PASSWORD_PARAM')] = pass;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
